import React from 'react';

import { Toggle } from 'src/components/molecules/Toggle/Toggle';
import type { FacetOptionsProps } from './types';
import { formatOptionCount } from './utils/formatOptionCount';

export const FacetOptionsSingle = ({ boldText, facet }: FacetOptionsProps) => {
  return (
    <>
      {facet.options.map((option) => (
        <Toggle
          active={option.active}
          boldText={boldText}
          crawlable={option.crawlable}
          disabled={!option.active && option.count === 0}
          href={option.href}
          key={option.value}
          label={option.title}
          name={facet.key} // Use facet key as the group name for mutually exclusive behavior
          secondaryLabelText={formatOptionCount(option.count)}
          value={option.value}
        />
      ))}
    </>
  );
};
